/**
 * @generated SignedSource<<f3915fdbe9f7a8659b042dda99c01d58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NotifiableEventType = "ACCESS_CODE" | "ADDED_TO_BOOKING" | "ADDED_TO_EVENT" | "ADDED_TO_EVENT_WAITLIST" | "BOOKING_CANCELED" | "BOOKING_CREATED" | "BOOKING_REMINDER_1" | "BOOKING_REMINDER_2" | "BOOKING_REMINDER_3" | "BOOKING_REQUESTED" | "BOOKING_RESCHEDULED" | "BOOKING_SCHEDULED" | "BOOKING_UPDATED" | "CADDIE_ADDED_TO_BOOKING" | "CADDIE_BOOKING_CANCELED" | "CADDIE_BOOKING_REMINDER" | "CADDIE_BOOKING_UPDATED" | "CADDIE_REMOVED_FROM_BOOKING" | "EVENT_REMINDER_1" | "EVENT_REMINDER_2" | "EVENT_REMINDER_3" | "LESSON_CANCELED" | "LESSON_CONFIRMED" | "LESSON_RESCHEDULED" | "MEMBER_HOLD_REMINDER_1" | "MEMBER_HOLD_REMINDER_2" | "MEMBER_HOLD_REMINDER_3" | "NEW_LESSON_REQUEST" | "PACKAGE_CANCELED" | "PACKAGE_PAYMENT_FAILED" | "PACKAGE_PURCHASED" | "PAIRINGS_PUBLISHED" | "REMOVED_FROM_BOOKING" | "REMOVED_FROM_BOOKING" | "REMOVED_FROM_EVENT" | "REQUESTED_TIME_AVAILABLE";
export type TimeUnit = "HOUR" | "MINUTE";
import { FragmentRefs } from "relay-runtime";
export type RemoteLockCode_BookingSummaryRemoteLockCodeConfig$data = {
  readonly bookingNotificationSettings: {
    readonly notifiableEventSettings: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly sendBeforeTimeAmount: number | null | undefined;
          readonly sendBeforeTimeUnit: TimeUnit | null | undefined;
          readonly type: NotifiableEventType;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RemoteLockCode_BookingSummaryRemoteLockCodeConfig";
};
export type RemoteLockCode_BookingSummaryRemoteLockCodeConfig$key = {
  readonly " $data"?: RemoteLockCode_BookingSummaryRemoteLockCodeConfig$data;
  readonly " $fragmentSpreads": FragmentRefs<"RemoteLockCode_BookingSummaryRemoteLockCodeConfig">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoteLockCode_BookingSummaryRemoteLockCodeConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationSettings",
      "kind": "LinkedField",
      "name": "bookingNotificationSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": [
                "ACCESS_CODE"
              ]
            }
          ],
          "concreteType": "NotifiableEventSettingsConnection",
          "kind": "LinkedField",
          "name": "notifiableEventSettings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NotifiableEventSettingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotifiableEventSettings",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendBeforeTimeAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendBeforeTimeUnit",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "notifiableEventSettings(type:[\"ACCESS_CODE\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "c35ef8a7e7c6336d3f17836afdaa9bb3";

export default node;
